import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import * as actionTypes from "../../../store/Actions/actions";
import CloneICON from "../../../assets/images/clone.svg";
import * as UTILS from "../../../utils/Utils";
import TinyMCEHTMLEditor from "./TinyMCETABLEEditor";
import TinyTableMobile from "./TinyTableMobile";
import "./Table.scss";
import Popup from "../../Modal/Popup";
import Counter from "../../Tool/Counter/Counter";
import cloneDeep from "lodash.clonedeep";
import UnitSelector from "../../Tool/UnitSelector/UnitSelector";
import { track } from "@amplitude/analytics-browser";
import { getDesktopTableStyles, getMobileTableStyles, applyTableAlignment, justifyContentSelectValue } from "./tableUtils";
import { Tooltip } from "antd";
import ConditionalWrapper from "../../ui/ConditionalWrapper";

const TableEditor = (props) => {
  const [tableSettings, setTableSettings] = useState(false)

  const toggleTableHeaderOrColumnSticky = (e) => {
    if (e.target.value == "fixedHeader") {
      const fullWidthDesk = props.element.desktopStyle.height;

      track("Table Configuration Applied", {
        StickyHeader: e.target.checked,
        StickyFirstColumn: e.target.checked,
      });
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.ID,
        (item) => {
          item.desktopStyle.tableHeaderSticky =
            e.target.checked

          item.desktopStyle.height = fullWidthDesk;
          item.desktopStyle.fullHeight = false;
        },
        (colItem) => {
          colItem.desktopStyle.tableHeaderSticky = e.target.checked
          colItem.desktopStyle.height = fullWidthDesk;
          colItem.desktopStyle.fullHeight = false;
        },
        (colItemNested) => {
          colItemNested.desktopStyle.tableHeaderSticky = e.target.checked;
          colItemNested.desktopStyle.height = fullWidthDesk;
          colItemNested.desktopStyle.fullHeight = false;
        }
      );

      props.layoutArray(props.layoutTitle, newLayout);
    }

    if (e.target.value == "fixedColumn") {
      track("Table Configuration Applied", {
        StickyHeader: e.target.checked,
        StickyFirstColumn: e.target.checked,
      });

      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.ID,
        (item) => {
          item.desktopStyle.tableColumnSticky =
            e.target.checked
        },
        (colItem) => {
          colItem.desktopStyle.tableColumnSticky =
            e.target.checked
        },
        (colItemNested) => {
          colItemNested.desktopStyle.tableColumnSticky =
            e.target.checked
        }
      );

      props.layoutArray(props.layoutTitle, newLayout);
    }
  };
  const toggleMobileTableHeaderOrColumnSticky = (e) => {
    const fullWidthMobile = props.element.mobileStyle.height;
    if (e.target.value == "fixedHeader") {
      track("Mobile Table Configuration Applied", {
        MobileStickyHeader:
          e.target.checked,
        MobileStickyFirstColumn:
          e.target.checked
      });
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.ID,
        (item) => {
          item.mobileStyle.tableHeaderSticky =
            e.target.checked
          item.mobileStyle.height = fullWidthMobile;
          item.mobileStyle.fullHeight = false;
        },
        (colItem) => {
          colItem.mobileStyle.tableHeaderSticky =
            e.target.checked
          colItem.mobileStyle.height = fullWidthMobile;
          colItem.mobileStyle.fullHeight = false;
        },
        (colItemNested) => {
          colItemNested.mobileStyle.tableHeaderSticky =
            e.target.checked
          colItemNested.mobileStyle.height = fullWidthMobile;
          colItemNested.mobileStyle.fullHeight = false;
        }
      );

      props.layoutArray(props.layoutTitle, newLayout);
    }

    if (e.target.value == "fixedColumn") {
      track("Mobile Table Configuration Applied", {
        MobileStickyHeader:
          e.target.checked,
        MobileStickyFirstColumn:
          e.target.checked
      });
      let layout = cloneDeep(props.layout);
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.ID,
        (item) => {
          item.mobileStyle.tableColumnSticky =
            e.target.checked
        },
        (colItem) => {
          colItem.mobileStyle.tableColumnSticky =
            e.target.checked
        },
        (colItemNested) => {
          colItemNested.mobileStyle.tableColumnSticky =
            e.target.checked
        }
      );

      props.layoutArray(props.layoutTitle, newLayout);
    }
  };

  const counterPlus = (value, property, mediaType) => {
    const layout = cloneDeep(props.layout);
    const selectedValue = value;

    if (mediaType == "desktop") {
      var newLayout = UTILS.UpdateLayout(
        layout,
        props.ID,
        (item) => {
          item.desktopStyle[property] = JSON.stringify(
            JSON.parse(selectedValue) + 1
          );
        },
        (colItem) => {
          colItem.desktopStyle[property] = JSON.stringify(
            JSON.parse(selectedValue) + 1
          );
        },
        (colItemNested) => {
          colItemNested.desktopStyle[property] = JSON.stringify(
            JSON.parse(selectedValue) + 1
          );
        }
      );
    }
    if (mediaType == "mobile") {
      var newLayout = UTILS.UpdateLayout(
        layout,
        props.ID,
        (item) => {
          item.mobileStyle[property] = JSON.stringify(
            JSON.parse(selectedValue) + 1
          );
        },
        (colItem) => {
          colItem.mobileStyle[property] = JSON.stringify(
            JSON.parse(selectedValue) + 1
          );
        },
        (colItemNested) => {
          colItemNested.mobileStyle[property] = JSON.stringify(
            JSON.parse(selectedValue) + 1
          );
        }
      );
    }

    props.layoutArray(props.layoutTitle, newLayout);
  };

  const counterMinus = (value, property, mediaType) => {
    const layout = cloneDeep(props.layout);
    const selectedValue = value;

    if (mediaType == "desktop") {
      var newLayout = UTILS.UpdateLayout(
        layout,
        props.ID,
        (item) => {
          item.desktopStyle[property] = JSON.stringify(
            JSON.parse(selectedValue) - 1
          );
        },
        (colItem) => {
          colItem.desktopStyle[property] = JSON.stringify(
            JSON.parse(selectedValue) - 1
          );
        },
        (colItemNested) => {
          colItemNested.desktopStyle[property] = JSON.stringify(
            JSON.parse(selectedValue) - 1
          );
        }
      );
    }

    if (mediaType == "mobile") {
      var newLayout = UTILS.UpdateLayout(
        layout,
        props.ID,
        (item) => {
          item.mobileStyle[property] = JSON.stringify(
            JSON.parse(selectedValue) - 1
          );
        },
        (colItem) => {
          colItem.mobileStyle[property] = JSON.stringify(
            JSON.parse(selectedValue) - 1
          );
        },
        (colItemNested) => {
          colItemNested.mobileStyle[property] = JSON.stringify(
            JSON.parse(selectedValue) - 1
          );
        }
      );
    }
    props.layoutArray(props.layoutTitle, newLayout);
  };
  const counterChange = (e, property, mediaType) => {
    const layout = cloneDeep(props.layout);

    const selectedValue =
      e.target.value !== "" && e.target.value !== "0" && e.target.value !== "00"
        ? e.target.value.replace(/\b0+/g, "")
        : "0";

    if (mediaType == "desktop") {
      var newLayout = UTILS.UpdateLayout(
        layout,
        props.ID,
        (item) => {
          item.desktopStyle[property] = selectedValue;
        },
        (colItem) => {
          colItem.desktopStyle[property] = selectedValue;
        },
        (colItemNested) => {
          colItemNested.desktopStyle[property] = selectedValue;
        }
      );
    }
    if (mediaType == "mobile") {
      var newLayout = UTILS.UpdateLayout(
        layout,
        props.ID,
        (item) => {
          item.mobileStyle[property] = selectedValue;
        },
        (colItem) => {
          colItem.mobileStyle[property] = selectedValue;
        },
        (colItemNested) => {
          colItemNested.mobileStyle[property] = selectedValue;
        }
      );
    }

    props.layoutArray(props.layoutTitle, newLayout);
  };
  const unitValueChange = (e, property, property2) => {
    const layout = cloneDeep(props.layout);
    const selectedValue = e.target.value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      props.ID,
      (item) => {
        item[property] = selectedValue;
        item[property2] = selectedValue;
      },
      (colItem) => {
        colItem[property] = selectedValue;
        colItem[property2] = selectedValue;
      },
      (colItemNested) => {
        colItemNested[property] = selectedValue;
        colItemNested[property2] = selectedValue;
      }
    );
    props.layoutArray(props.layoutTitle, newLayout);
  };

  const heightToggle = (e, property, view) => {
    const layout = cloneDeep(props.layout);

    const fullWidthDesk = props.element.desktopStyle.height;

    const fullWidthMobile = props.element.mobileStyle.height;

    if (view == "mobile") {
      var newLayout = UTILS.UpdateLayout(
        layout,
        props.ID,
        (item) => {
          item.mobileStyle.height = fullWidthMobile;
          item.mobileStyle.fullHeight =
            !props.element.mobileStyle.fullHeight;
        },
        (colItem) => {
          colItem.mobileStyle.height = fullWidthMobile;
          colItem.mobileStyle.fullHeight =
            !props.element.mobileStyle.fullHeight;
        },
        (colItemNested) => {
          colItemNested.mobileStyle.height = fullWidthMobile;
          colItemNested.mobileStyle.fullHeight =
            !props.element.mobileStyle.fullHeight;
        }
      );
    }
    if (view == "desktop") {
      var newLayout = UTILS.UpdateLayout(
        layout,
        props.ID,
        (item) => {
          item.desktopStyle.height = fullWidthDesk;
          item.desktopStyle.fullHeight =
            !props.element.desktopStyle.fullHeight;
        },
        (colItem) => {
          colItem.desktopStyle.height = fullWidthDesk;
          colItem.desktopStyle.fullHeight =
            !props.element.desktopStyle.fullHeight;
        },
        (colItemNested) => {
          colItemNested.desktopStyle.height = fullWidthDesk;
          colItemNested.desktopStyle.fullHeight =
            !props.element.desktopStyle.fullHeight;
        }
      );
    }

    props.layoutArray(props.layoutTitle, newLayout);
  };

  const alignmentChange = (e, mediaType) => {
    const layout = cloneDeep(props.layout);
    const selectedValue = e.target.value;
    const isMobile = props.mobileView;
    const isMirrored = props.isMirrored;

    const property = isMirrored ? "desktopStyle" : "mobileStyle";

    let content = applyTableAlignment(props.element.desktopStyle.content, selectedValue);

    if (isMobile) {
      content = applyTableAlignment(props.element[property].content, selectedValue);
    }
    const newLayout = UTILS.UpdateLayout(
      layout,
      props.ID,
      (item) => {
        if (isMobile) {
          item[property].justifyContent = selectedValue;
          item[property].content = content;
        } else {
          item.desktopStyle.justifyContent = selectedValue;
          item.desktopStyle.content = content;
        }
      },
      (colItem) => {
        if (isMobile) {
          colItem[property].justifyContent = selectedValue;
          colItem[property].content = content;
        } else {
          colItem.desktopStyle.justifyContent = selectedValue;
          colItem.desktopStyle.content = content;
        }
      },
      (colItemNested) => {
        if (isMobile) {
          colItemNested[property].justifyContent = selectedValue;
          colItemNested[property].content = content;
        } else {
          colItemNested.desktopStyle.justifyContent = selectedValue;
          colItemNested.desktopStyle.content = content;
        }
      }
    );
    props.layoutArray(props.layoutTitle, newLayout);
  };

  const mirrorDesktopToggle = (e) => {
    const layout = cloneDeep(props.layout);
    if (props.isMirrored == true) {
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.ID,
        (item) => {
          item.isMirrored = false;
        },
        (colItem) => {
          colItem.isMirrored = false;
        },
        (colItemNested) => {
          colItemNested.isMirrored = false;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    } else {
      const newLayout = UTILS.UpdateLayout(
        layout,
        props.ID,
        (item) => {
          item.isMirrored = true;
        },
        (colItem) => {
          colItem.isMirrored = true;
        },
        (colItemNested) => {
          colItemNested.isMirrored = true;
        }
      );
      props.layoutArray(props.layoutTitle, newLayout);
    }
  };

  const addTableLabel = (event) => {
    /* signal to React not to nullify the event object */
    event.persist();

    const layout = cloneDeep(props.layout);
    const selectedValue = event.target.value;
    const newLayout = UTILS.UpdateLayout(
      layout,
      props.ID,
      (item) => {
        item.label = selectedValue;
      },
      (colItem) => {
        colItem.label = selectedValue;
      },
      (colItemNested) => {
        colItemNested.label = selectedValue;
      }
    );
    props.layoutArray(props.layoutTitle, newLayout);
  };

  return (
    <div className="table-wrapper">
      <div
        id={"table-wrapper-" + props.ID}
        style={
          !!props.mobileView
            ? getMobileTableStyles(props)
            : getDesktopTableStyles(props)

        }
      >
        <div className="actionControl">
          <span
            className="image-setting"
            onClick={() => {
              setTableSettings(true)
            }}
          >
            Table Settings
          </span>
          <button className="clone-item" onClick={() => { props.cloneElement(props.element.id) }}>
            <img src={CloneICON} />
          </button>
          <span className="delete-item" onClick={() => { props.deleteElement(props.element.id) }}>
            <i className="far fa-trash-alt" />
          </span>
        </div>

        {props.mobileView ? (
          <TinyTableMobile
            selectedFont={props.selectedFont}
            settingsOpen={tableSettings}
            mobileView={props.mobileView}
            element={props.element}
            pagesList={props.pagesList}
            ID={props.ID}
            isMirrored={props.isMirrored}
            mobileContent={
              props.isMirrored == true
                ? props.desktopContent
                : props.mobileContent
            }
            desktopContent={props.desktopContent}
            preset={props.preset}
            elementsFont={props.elementsFont}
            layoutTitle={props.layoutTitle}
            layout={props.layout}
            layoutArray={props.layoutArray}
          />
        ) : (
          <TinyMCEHTMLEditor
            fullHeight={props.element.desktopStyle.fullHeight}
            settingsOpen={tableSettings}
            selectedFont={props.selectedFont}
            isMirrored={props.isMirrored}
            mobileView={props.mobileView}
            element={props.element}
            pagesList={props.pagesList}
            ID={props.ID}
            mobileContent={
              props.isMirrored == true
                ? props.desktopContent
                : props.mobileContent
            }
            desktopContent={props.desktopContent}
            preset={props.preset}
            elementsFont={props.elementsFont}
            layoutTitle={props.layoutTitle}
            layoutArray={props.layoutArray}
            layout={props.layout}
          />
        )}

        {tableSettings ? (
          <Popup
            width="700"
            header="Table Container Settings"
            parentID="moduleBgChange"
            closePopup={() => {
              setTableSettings(false);
            }}
            close={() => {
              setTableSettings(false);
            }}
          >
            <div className="modalScrollContainerSecondary">
              <div
                className="d-flex"
                style={{ flexWrap: "wrap", flexDirection: "row" }}
              >
                <div className="modalContentWrapper">
                  <label>
                    Table Label{" "}
                    <small> (For Meta Data and Aria Labels)</small>
                  </label>
                  <input
                    onChange={addTableLabel}
                    defaultValue={props.label}
                    placeholder="Add Table Label"
                    className="tableLabelInput"
                    type="text"
                  />
                </div>
                <div
                  style={{ marginTop: "30px", marginBottom: "5px" }}
                  className="padding-section"
                >
                  <div className="heading">Sticky Header/Column</div>
                </div>
                <div
                  style={{ display: "flex", flexDirection: "column" }}
                  className="modalContentWrapper"
                >
                  <div
                    style={{ marginBottom: "10px" }}
                    className="heading-row"
                  >
                    Desktop
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      alignItems: "center",
                      marginBottom: "10px",
                    }}
                  >
                    <input
                      key={Math.random()}
                      style={{ marginRight: "10px" }}
                      onChange={toggleTableHeaderOrColumnSticky}
                      value="fixedHeader"
                      type="checkbox"
                      checked={
                        props.element.desktopStyle.tableHeaderSticky ==
                          true
                          ? true
                          : false
                      }
                    ></input>
                    <label>
                      Sticky Header: Lock Header position on scroll.
                    </label>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      alignItems: "center",
                      marginBottom: "10px",
                    }}
                  >
                    <input
                      key={Math.random()}
                      style={{ marginRight: "10px" }}
                      onChange={toggleTableHeaderOrColumnSticky}
                      value="fixedColumn"
                      type="checkbox"
                      checked={
                        props.element.desktopStyle.tableColumnSticky ==
                          true
                          ? true
                          : false
                      }
                    ></input>
                    <label>
                      Sticky Column: Lock Left Most Column position on scroll.
                    </label>
                  </div>
                  <div
                    style={{ marginBottom: "10px" }}
                    className="heading-row"
                  >
                    Mobile
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      alignItems: "center",
                      marginBottom: "10px",
                    }}
                  >
                    <input
                      key={Math.random()}
                      style={{ marginRight: "10px" }}
                      onChange={toggleMobileTableHeaderOrColumnSticky}
                      value="fixedHeader"
                      type="checkbox"
                      checked={
                        !!props.element.mobileStyle.mobileTableHeaderSticky ||
                          !!props.element.mobileStyle.tableHeaderSticky
                          ? true
                          : false
                      }
                    ></input>
                    <label>
                      Sticky Header: Lock Header position on scroll.
                    </label>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      width: "100%",
                      alignItems: "center",
                      marginBottom: "10px",
                    }}
                  >
                    <input
                      key={Math.random()}
                      style={{ marginRight: "10px" }}
                      onChange={toggleMobileTableHeaderOrColumnSticky}
                      value="fixedColumn"
                      type="checkbox"
                      checked={
                        !!props.element.mobileStyle.mobileTableColumnSticky ||
                          !!props.element.mobileStyle.tableColumnSticky
                          ? true
                          : false
                      }
                    ></input>
                    <label>
                      Sticky Column: Lock Left Most Column position on scroll.
                    </label>
                  </div>
                </div>
                <div
                  style={{ marginTop: "30px", marginBottom: "5px" }}
                  className="padding-section"
                >
                  <div className="heading">Height</div>
                </div>
                <div
                  style={{ display: "flex", flexDirection: "row" }}
                  className="modalContentWrapper"
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <div className="heading-row">Desktop</div>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <Counter
                        label="Height"
                        small={"pixels"}
                        minusClick={() =>
                          counterMinus(
                            props.element.desktopStyle &&
                              props.element.desktopStyle.height
                              ? props.element.desktopStyle.height
                              : "0",
                            "height",
                            "desktop"
                          )
                        }
                        valueContent={
                          props.element.desktopStyle.fullHeight
                            ? ""
                            : props.element.desktopStyle.height
                        }
                        onChange={(e) => {
                          counterChange(e, "height", "desktop");
                        }}
                        plusClick={() => {
                          counterPlus(
                            props.element.desktopStyle &&
                              props.element.desktopStyle.height
                              ? props.element.desktopStyle.height
                              : "0",
                            "height",
                            "desktop"
                          );
                        }}
                      />
                      <ConditionalWrapper
                        condition={props.element.desktopStyle.tableHeaderSticky}
                        wrapper={(children) => (
                          <Tooltip title="Uncheck Sticky Header to enable Auto Height" >{children}</Tooltip>
                        )}
                      >
                        <div style={{ marginLeft: "25px" }} className="wrap">
                          <label>Auto</label>
                          <input
                            key={Math.random()}
                            className="checkMark"
                            type="checkbox"
                            id="fullWidthCheck"
                            name="fullwidth"
                            disabled={
                              props.element.desktopStyle.tableHeaderSticky
                                ? true
                                : false
                            }
                            onChange={(e) => {
                              heightToggle(e, "height", "desktop");
                            }}
                            style={{
                              cursor: props.element.desktopStyle.tableHeaderSticky ? 'not-allowed' : 'pointer',
                            }}
                            checked={props.element.desktopStyle.fullHeight}
                          />
                          <label htmlFor="fullWidthCheck"></label>
                        </div>
                      </ConditionalWrapper>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <div className="heading-row">Mobile</div>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <Counter
                        label="Height"
                        small={"pixels"}
                        minusClick={() =>
                          counterMinus(
                            props.element.mobileStyle &&
                            props.element.mobileStyle.height,
                            "height",
                            "mobile"
                          )
                        }
                        onChange={(e) => {
                          counterChange(e, "height", "mobile");
                        }}
                        valueContent={
                          props.element.mobileStyle.fullHeight
                            ? ""
                            : props.element.mobileStyle.height
                        }
                        plusClick={() => {
                          counterPlus(
                            props.element.mobileStyle &&
                            props.element.mobileStyle.height,
                            "height",
                            "mobile"
                          );
                        }}
                      />
                      <ConditionalWrapper
                        condition={props.element.mobileStyle.mobileTableHeaderSticky || props.element.mobileStyle.tableHeaderSticky}
                        wrapper={(children) => (
                          <Tooltip title="Uncheck Mobile Sticky Header to enable Auto Height" >{children}</Tooltip>
                        )}
                      >
                        <div style={{ marginLeft: "25px" }} className="wrap">
                          <label>Auto</label>
                          <input
                            key={Math.random()}
                            className="checkMark"
                            type="checkbox"
                            id="fullWidthCheckMobile"
                            name="fullwidthMobile"
                            disabled={
                              props.element.mobileStyle.mobileTableHeaderSticky || props.element.mobileStyle.tableHeaderSticky
                                ? true
                                : false
                            }
                            onChange={(e) => {
                              heightToggle(e, "height", "mobile");
                            }}
                            style={{
                              cursor: props.element.mobileStyle.mobileTableHeaderSticky || props.element.mobileStyle.tableHeaderSticky ? 'not-allowed' : 'pointer',
                            }}
                            checked={props.element.mobileStyle.fullHeight}
                          />
                          <label htmlFor="fullWidthCheckMobile"></label>
                        </div>
                      </ConditionalWrapper>
                    </div>
                  </div>
                </div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    position: "relative",
                    justifyContent: "right",
                    paddingRight: "20px",
                    marginBottom: "0px",
                    width: "100%",
                  }}
                ></div>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    position: "relative",
                    justifyContent: "right",
                    paddingRight: "20px",
                    marginBottom: "0px",
                    width: "100%",
                  }}
                ></div>
                <div
                  style={{ marginTop: "30px", marginBottom: "5px" }}
                  className="padding-section"
                >
                  <div className="heading">Padding</div>
                </div>
                <div
                  className="modalContentWrapper"
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-end",
                  }}
                >
                  <UnitSelector
                    defaultValue={
                      props.tableDesktopUnit
                        ? props.tableDesktopUnit
                        : "px"
                    }
                    onChange={(e) => {
                      unitValueChange(
                        e,
                        "tableMobileUnit",
                        "tableDesktopUnit"
                      );
                    }}
                  />
                </div>
                <div
                  style={{ display: "flex", flexDirection: "row" }}
                  className="modalContentWrapper"
                >
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <div className="heading-row">Desktop</div>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div className="d-block">
                        <Counter
                          label="Top"
                          small={
                            props.tableDesktopUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          minusClick={() =>
                            counterMinus(
                              props.element.desktopStyle &&
                                props.element.desktopStyle.marginTop
                                ? props.element.desktopStyle.marginTop
                                : "0",
                              "marginTop",
                              "desktop"
                            )
                          }
                          valueContent={
                            props.element.desktopStyle &&
                              props.element.desktopStyle.marginTop
                              ? props.element.desktopStyle.marginTop
                              : "0"
                          }
                          disabled={false}
                          onChange={(e) => {
                            counterChange(e, "marginTop", "desktop");
                          }}
                          plusClick={() => {
                            counterPlus(
                              props.element.desktopStyle &&
                                props.element.desktopStyle.marginTop
                                ? props.element.desktopStyle.marginTop
                                : "0",
                              "marginTop",
                              "desktop"
                            );
                          }}
                        />
                      </div>
                      <div className="d-block">
                        <Counter
                          label="Bottom"
                          small={
                            props.tableDesktopUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          minusClick={() =>
                            counterMinus(
                              props.element.desktopStyle &&
                                props.element.desktopStyle.marginBottom
                                ? props.element.desktopStyle.marginBottom
                                : "0",
                              "marginBottom",
                              "desktop"
                            )
                          }
                          valueContent={
                            props.element.desktopStyle &&
                              props.element.desktopStyle.marginBottom
                              ? props.element.desktopStyle.marginBottom
                              : "0"
                          }
                          disabled={false}
                          onChange={(e) => {
                            counterChange(e, "marginBottom", "desktop");
                          }}
                          plusClick={() =>
                            counterPlus(
                              props.element.desktopStyle &&
                                props.element.desktopStyle.marginBottom
                                ? props.element.desktopStyle.marginBottom
                                : "0",
                              "marginBottom",
                              "desktop"
                            )
                          }
                        />
                      </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div className="d-block">
                        <Counter
                          label="Left"
                          small={
                            props.tableDesktopUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          minusClick={() =>
                            counterMinus(
                              props.element.desktopStyle &&
                                props.element.desktopStyle.paddingLeft
                                ? props.element.desktopStyle.paddingLeft
                                : "0",
                              "paddingLeft",
                              "desktop"
                            )
                          }
                          valueContent={
                            props.element.desktopStyle &&
                              props.element.desktopStyle.paddingLeft
                              ? props.element.desktopStyle.paddingLeft
                              : "0"
                          }
                          disabled={false}
                          onChange={(e) => {
                            counterChange(e, "paddingLeft", "desktop");
                          }}
                          plusClick={() => {
                            counterPlus(
                              props.element.desktopStyle &&
                                props.element.desktopStyle.paddingLeft
                                ? props.element.desktopStyle.paddingLeft
                                : "0",
                              "paddingLeft",
                              "desktop"
                            );
                          }}
                        />
                      </div>
                      <div className="d-block">
                        <Counter
                          label="Right"
                          small={
                            props.tableDesktopUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          minusClick={() =>
                            counterMinus(
                              props.element.desktopStyle &&
                                props.element.desktopStyle.paddingRight
                                ? props.element.desktopStyle.paddingRight
                                : "0",
                              "paddingRight",
                              "desktop"
                            )
                          }
                          valueContent={
                            props.element.desktopStyle &&
                              props.element.desktopStyle.paddingRight
                              ? props.element.desktopStyle.paddingRight
                              : "0"
                          }
                          disabled={false}
                          onChange={(e) => {
                            counterChange(e, "paddingRight", "desktop");
                          }}
                          plusClick={() =>
                            counterPlus(
                              props.element.desktopStyle &&
                                props.element.desktopStyle.paddingRight
                                ? props.element.desktopStyle.paddingRight
                                : "0",
                              "paddingRight",
                              "desktop"
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "50%",
                    }}
                  >
                    <div className="heading-row">Mobile</div>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div className="d-block">
                        <Counter
                          label="Top"
                          small={
                            props.tableMobileUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          minusClick={() =>
                            counterMinus(
                              props.element.mobileStyle &&
                                props.element.mobileStyle.marginTop
                                ? props.element.mobileStyle.marginTop
                                : "0",
                              "marginTop",
                              "mobile"
                            )
                          }
                          onChange={(e) => {
                            counterChange(e, "marginTop", "mobile");
                          }}
                          valueContent={
                            props.element.mobileStyle &&
                              props.element.mobileStyle.marginTop
                              ? props.element.mobileStyle.marginTop
                              : "0"
                          }
                          disabled={false}
                          plusClick={() => {
                            counterPlus(
                              props.element.mobileStyle &&
                                props.element.mobileStyle.marginTop
                                ? props.element.mobileStyle.marginTop
                                : "0",
                              "marginTop",
                              "mobile"
                            );
                          }}
                        />
                      </div>
                      <div className="d-block">
                        <Counter
                          label="Bottom"
                          small={
                            props.tableMobileUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          minusClick={() =>
                            counterMinus(
                              props.element.mobileStyle &&
                                props.element.mobileStyle.marginBottom
                                ? props.element.mobileStyle.marginBottom
                                : "0",
                              "marginBottom",
                              "mobile"
                            )
                          }
                          valueContent={
                            props.element.mobileStyle &&
                              props.element.mobileStyle.marginBottom
                              ? props.element.mobileStyle.marginBottom
                              : "0"
                          }
                          disabled={false}
                          onChange={(e) => {
                            counterChange(e, "marginBottom", "mobile");
                          }}
                          plusClick={() =>
                            counterPlus(
                              props.element.mobileStyle &&
                                props.element.mobileStyle.marginBottom
                                ? props.element.mobileStyle.marginBottom
                                : "0",
                              "marginBottom",
                              "mobile"
                            )
                          }
                        />
                      </div>
                    </div>
                    <div style={{ display: "flex", flexDirection: "row" }}>
                      <div className="d-block">
                        <Counter
                          label="Left"
                          small={
                            props.tableMobileUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          minusClick={() =>
                            counterMinus(
                              props.element.mobileStyle &&
                                props.element.mobileStyle.paddingLeft
                                ? props.element.mobileStyle.paddingLeft
                                : "0",
                              "paddingLeft",
                              "mobile"
                            )
                          }
                          valueContent={
                            props.element.mobileStyle &&
                              props.element.mobileStyle.paddingLeft
                              ? props.element.mobileStyle.paddingLeft
                              : "0"
                          }
                          disabled={false}
                          onChange={(e) => {
                            counterChange(e, "paddingLeft", "mobile");
                          }}
                          plusClick={() => {
                            counterPlus(
                              props.element.mobileStyle &&
                                props.element.mobileStyle.paddingLeft
                                ? props.element.mobileStyle.paddingLeft
                                : "0",
                              "paddingLeft",
                              "mobile"
                            );
                          }}
                        />
                      </div>
                      <div className="d-block">
                        <Counter
                          label="Right"
                          small={
                            props.tableMobileUnit === "%"
                              ? "percent"
                              : "pixel"
                          }
                          minusClick={() =>
                            counterMinus(
                              props.element.mobileStyle &&
                                props.element.mobileStyle.paddingRight
                                ? props.element.mobileStyle.paddingRight
                                : "0",
                              "paddingRight",
                              "mobile"
                            )
                          }
                          valueContent={
                            props.element.mobileStyle &&
                              props.element.mobileStyle.paddingRight
                              ? props.element.mobileStyle.paddingRight
                              : "0"
                          }
                          disabled={false}
                          onChange={(e) => {
                            counterChange(e, "paddingRight", "mobile");
                          }}
                          plusClick={() =>
                            counterPlus(
                              props.element.mobileStyle &&
                                props.element.mobileStyle.paddingRight
                                ? props.element.mobileStyle.paddingRight
                                : "0",
                              "paddingRight",
                              "mobile"
                            )
                          }
                        />
                      </div>
                    </div>
                  </div>
                </div>
                {!props.mobileView && <>
                  <div
                    style={{ marginTop: "30px", marginBottom: "5px" }}
                    className="padding-section"
                  >
                    <div className="heading">Alignment</div>
                  </div>
                  <div
                    style={{ display: "flex", flexDirection: "row" }}
                    className="modalContentWrapper"
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "100%",
                      }}
                    >
                      <div style={{ display: "flex", flexDirection: "row", width: "100%", alignItems: "center", justifyContent: "space-between" }}>
                        <label style={{ display: "block", marginBottom: "5px" }}>Table Alignment</label>
                        <select
                          value={justifyContentSelectValue(props)}
                          onChange={(e) => {
                            alignmentChange(e);
                          }}
                          style={{
                            width: "50%",
                            padding: "8px",
                            border: "1px solid #ccc",
                            borderRadius: "4px",
                            fontSize: "14px",
                          }}
                        // disabled={isMobile}
                        >
                          <option value="flex-start">Left</option>
                          <option value="center">Center</option>
                          <option value="flex-end">Right</option>
                        </select>
                      </div>
                    </div>
                  </div>
                </>}
                <div
                  style={{ marginTop: "30px", marginBottom: "5px" }}
                  className="padding-section"
                >
                  <div className="heading">Content Mirroring</div>
                </div>
                <div
                  style={{ display: "flex", flexDirection: "row" }}
                  className="modalContentWrapper"
                >
                  <div
                    style={{
                      justifyContent: "center",
                      position: "relative",
                      alignItems: "center",
                      marginRight: "30px",
                    }}
                  >
                    <label>Mirrored Views</label>

                    <input
                      key={Math.random()}
                      className="checkMark"
                      type="checkbox"
                      id="mirrorDesktop"
                      name="mirrorDesktop"
                      // value="percentage"
                      onChange={(e) => {
                        mirrorDesktopToggle(e);
                      }}
                      checked={props.isMirrored == true ? true : false}
                    />
                    <label htmlFor="mirrorDesktop"></label>
                    <small style={{ fontSize: "10px" }}>
                      {`(Table element will have the same view on desktop
                      and mobile. Editing one version of the view will affect
                      the other.)`}
                    </small>
                  </div>

                  <div
                    style={{
                      justifyContent: "center",
                      position: "relative",
                      alignItems: "center",
                      marginRight: "30px",
                    }}
                  >
                    <label>Unique Views</label>

                    <input
                      key={Math.random()}
                      className="checkMark"
                      type="checkbox"
                      id="mirrorDesktopOff"
                      name="mirrorDesktopOff"
                      // value="percentage"
                      onChange={(e) => {
                        mirrorDesktopToggle(e);
                      }}
                      checked={props.isMirrored == true ? false : true}
                    />
                    <label htmlFor="mirrorDesktopOff"></label>
                    <small style={{ fontSize: "10px" }}>
                      {`(Mobile and Desktop views are seperate. Editing done while in the mobile view will only apply to the mobile view and vice versa.)`}
                    </small>
                  </div>
                </div>
              </div>
            </div>
          </Popup>
        ) : (
          ""
        )}
      </div>
    </div >
  );

}
const mapStateToProps = (state) => {
  return {
    layout: state.present.layout,
    layoutTitle: state.present.layoutTitle,
    preset: state.present.preset,
    elementsFont: state.present.canvasStyle.elementsFont,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    layoutArray: (titleValue, layoutVal) =>
      dispatch(
        actionTypes.layout({ titleLayout: titleValue, layout: layoutVal })
      ),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(TableEditor);
